export default __webpack_public_path__ + "static/media/icon-map.b056fae9.svg";